
import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';

const ClubLoading: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      <div className="container mx-auto p-4 flex-1 flex items-center justify-center">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-8 bg-muted rounded w-40 mb-4"></div>
          <div className="h-64 bg-muted rounded w-full max-w-2xl"></div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ClubLoading;
